export default "__VITE_ASSET__U$4DRb8k__"